module.exports = __webpack_public_path__ + "static/media/21.72c1476d.svg";